export const SHOW_CHRISTMAS_THEME = false;
export const THEME_KEY = "THEME";
export const LOCAL_USER_KEY = "user";
export const LOCAL_AUTH_TYPE = "authType";
export const RING_CHART_COLOR_CONFIG = ["#FF9999", "#FFF4F4"];
export const PRACTICE_TIME_COUNT_MAP_KEY = "PRACTICE_TIME_COUNT_MAP_KEY";
export const PRACTICE_TIME_COUNT_MAP_EXP_MINUTES = 5;
export const LOCAL_GRADE_FILE_KEY = "GRADE_FILE";
export const LOCAL_GRADE_MAP_INDEX_KEY = "GRADE_MAP_ID";

export type LanguageCodeType = "en" | "vi" | "th" | "es";

export const DEFAULT_LANGUAGE_CODE: LanguageCodeType = "vi";

export const SUPPORT_LANGUAGE_CODE_LIST: LanguageCodeType[] = [
  "en",
  DEFAULT_LANGUAGE_CODE,
  "th",
  "es",
];

export interface GradeItem {
  from: number;
  to: number;
  asNumber: number;
  asString: string;
}

export const GRADE_MAPS: GradeItem[][] = [
  [
    {
      from: 0,
      to: 4,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 4,
      to: 5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 5,
      to: 5.5,
      asNumber: 1.5,
      asString: "D+",
    },
    {
      from: 5.5,
      to: 6.5,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 6.5,
      to: 7,
      asNumber: 2.5,
      asString: "C+",
    },
    {
      from: 7,
      to: 8,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 8,
      to: 8.5,
      asNumber: 3.5,
      asString: "B+",
    },
    {
      from: 8.5,
      to: 9,
      asNumber: 3.7,
      asString: "A",
    },
    {
      from: 9,
      to: 10,
      asNumber: 4,
      asString: "A+",
    },
  ],
  [
    {
      from: 0,
      to: 4,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 4,
      to: 4.5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 4.5,
      to: 5,
      asNumber: 1.3,
      asString: "D+",
    },
    {
      from: 5,
      to: 5.5,
      asNumber: 1.7,
      asString: "C-",
    },
    {
      from: 5.5,
      to: 6,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 6,
      to: 6.5,
      asNumber: 2.3,
      asString: "C+",
    },
    {
      from: 6.5,
      to: 7,
      asNumber: 2.7,
      asString: "B-",
    },
    {
      from: 7,
      to: 7.5,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 7.5,
      to: 8,
      asNumber: 3.3,
      asString: "B+",
    },
    {
      from: 8,
      to: 8.5,
      asNumber: 3.7,
      asString: "A",
    },
    {
      from: 8.5,
      to: 10,
      asNumber: 4,
      asString: "A+",
    },
  ],
  [
    {
      from: 0,
      to: 5,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 5,
      to: 5.5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 5.5,
      to: 6,
      asNumber: 1.3,
      asString: "D+",
    },
    {
      from: 6,
      to: 6.5,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 6.5,
      to: 7,
      asNumber: 2.3,
      asString: "C+",
    },
    {
      from: 7,
      to: 7.5,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 7.5,
      to: 8,
      asNumber: 3.3,
      asString: "B+",
    },
    {
      from: 8,
      to: 8.5,
      asNumber: 3.7,
      asString: "A",
    },
    {
      from: 8.5,
      to: 10,
      asNumber: 4,
      asString: "A+",
    },
  ],
  [
    {
      from: 0,
      to: 4,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 4,
      to: 5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 5,
      to: 5.5,
      asNumber: 1.5,
      asString: "D+",
    },
    {
      from: 5.5,
      to: 6.5,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 6.5,
      to: 7,
      asNumber: 2.5,
      asString: "C+",
    },
    {
      from: 7,
      to: 8,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 8,
      to: 8.5,
      asNumber: 3.5,
      asString: "B+",
    },
    {
      from: 8.5,
      to: 10,
      asNumber: 4,
      asString: "A",
    },
  ],
  [
    {
      from: 0,
      to: 4,
      asNumber: 0,
      asString: "F",
    },
    {
      from: 4,
      to: 5.5,
      asNumber: 1,
      asString: "D",
    },
    {
      from: 5.5,
      to: 7,
      asNumber: 2,
      asString: "C",
    },
    {
      from: 7,
      to: 8.5,
      asNumber: 3,
      asString: "B",
    },
    {
      from: 8.5,
      to: 10,
      asNumber: 4,
      asString: "A",
    },
  ],
];

export const LANGUAGES: { key: LanguageCodeType; value: string }[] = [
  {
    key: "en",
    value: "English",
  },
  {
    key: "vi",
    value: "Tiếng Việt",
  },
  {
    key: "th",
    value: "ภาษา",
  },
  {
    key: "es",
    value: "Spanish",
  },
];
